var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.manual)?_c('ManualForm',{attrs:{"manual":_vm.manual,"readonly":!_vm.hasPermission(_vm.Permission.DEPOSITORY_MANUAL_EDIT)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }